import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhatsappShareComponent } from './components/whatsapp-share/whatsapp-share.component';
import { SharedModule } from '../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    SharedModule
  ],
  declarations: [WhatsappShareComponent],
  exports: [WhatsappShareComponent]
})
export class WhatsappShareModule { }
